import { ContractorSchema } from "../../contractor";
import { EmployeeSchema } from "./employee";
import { object, z } from "zod";
import { CompanySchema } from "@/pages/requests/components";

export const ContractSchema = z.object({
  Id: z.number(),
  CompanyId: z.number(),
  Company: CompanySchema,
  ContractTypeId: z.number(),
  ContractType: object({
    Id: z.number(),
    ContractTypeAr: z.string(),
    ContractTypeEn: z.string(),
  }),
  ContractNo: z.string(),
  Description: z.string(),
  SiteId: z.string(),
  ValidityStartDate: z.string().or(z.date()),
  ValidityEndDate: z.string().or(z.date()),
  EmpNo: z.number(),
  Employee: EmployeeSchema,
  ContractorId: z.number(),
  Contractor: ContractorSchema,
  SectionId: z.number(),
  Section: object({
    SectionId: z.number(),
    SectionNameAr: z.string(),
    SectionNameEn: z.string(),
    IsLoaDept: z.boolean(),
  }),
  ContractorAdnocId: z.string(),
  Status: z.string(),
  Value: z.string().optional(),
});

export const ContractsListSchema = z.array(ContractSchema);

export const ContractsResponseSchema = z.object({
  LoaContracts: ContractsListSchema,
});

export type Contract = z.infer<typeof ContractSchema>;

export type ContractsList = z.infer<typeof ContractsListSchema>;

export interface ContractsPayload {
  email: string;
  contractNo?: string;
  contractorId: string;
  companyId?: number;
}
